import { UUID } from "io-ts-types/UUID";

import { FundraiserResponse } from "@every.org/common/src/codecs/entities";
import { SafeInt } from "@every.org/common/src/codecs/number";

import { ValidationStatus } from "src/components/InputContainer";
import { ContextNonprofit } from "src/context/NonprofitsContext/types";

export interface FundraiserValidationErrors {
  title?: ValidationStatus;
  description?: ValidationStatus;
  donationThankYouMessage?: ValidationStatus;
  coverYoutubeVideoUrl?: ValidationStatus;
  matchCampaign?: ValidationStatus;
  maxTotalMatchAmount?: ValidationStatus;
  currentTotalMatchAmount?: ValidationStatus;
  maxMatchPerDonationOneTimeAmount?: ValidationStatus;
  dateRange?: ValidationStatus;
  hasCoverOption?: ValidationStatus;
}

export interface FundraiserMatchCampaign {
  maxTotalMatchAmount: SafeInt;
  maxMatchPerDonationOneTimeAmount: SafeInt | null;
  startDate: Date | null;
  endDate: Date | null;
}

export interface PostFundraiser {
  title: string;
  description: string;
  creatorNonprofitId: UUID | null;
  coverImageCloudinaryId: string | null;
  goal: SafeInt | null;
  metadata: {
    donationThankYouMessage?: string;
    coverYoutubeVideoUrl?: string | null;
  } | null;
  raisedOffline: SafeInt | null;
  matchCampaign?: FundraiserMatchCampaign | undefined;
}

export interface UpdateFundraiser {
  title?: string;
  description?: string | null;
  coverImageCloudinaryId?: string | null;
  creatorNonprofitId?: UUID | null;
  goal?: SafeInt | null;
  pinned?: boolean;
  metadata?: {
    donationThankYouMessage?: string;
    coverYoutubeVideoUrl?: string | null;
  } | null;
  raisedOffline?: SafeInt | null;
}

export enum FundraiserEditFormKind {
  CREATE = "CREATE",
  EDIT = "EDIT",
}
export interface FundraiserEditFormProps {
  nonprofit: ContextNonprofit;
  fundraiser?: FundraiserResponse;
  // This will only be populated if the fundraiser is being created for multiple
  // nonprofits.
  forNonprofits?: string[];
  kind: FundraiserEditFormKind;
  onUnsavedChangesChange?: (hasChanges: boolean) => void;
}
